








































































































































import { mapState } from "vuex";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
// types
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      windowWidth: (state: IState) => state.ui.window.width
    })
  }
})
export default class MenuComponent extends Vue {
  @Prop({ required: true })
  private routes!: any[];

  @Prop({ default: "dark" })
  private background!: number;

  private windowWidth!: number;

  public get vm() {
    return this;
  }

  public get filteredRoutes() {
    return this.filterRoutes(this.routes);
  }

  public filterRoutes(routes) {
    return routes
      .filter(i => {
        if (
          this.$_.has(i, "if") &&
          !(this.$_.isFunction(i.if) ? i.if(this) : i.if)
        )
          return false;
        return true;
      })
      .map(i => {
        return {
          ...i,
          ...(this.$_.has(i, "children")
            ? { children: this.filterRoutes(i.children) }
            : {})
        };
      });
  }

  public autoClose($el: any, timeout = 0) {
    // Don't auto-close on desktops
    if (this.windowWidth > 768) {
      return;
    }
    if (this.$_.get(this.$parent, `$options.name`) === "SecondaryNav") {
      setTimeout(() => {
        const hasChildren = !!(
          $el.target.nextElementSibling &&
          $el.target.nextElementSibling.localName === "ul"
        );
        if (!hasChildren) {
          return this.$store.commit("ui/secondaryNav");
        }
        const isActive = $el.target.className
          .split(" ")
          .includes("router-link-active");
        if (isActive) {
          return this.$store.commit("ui/secondaryNav");
        }
      }, timeout);
    }
  }

  public checkGuards(route) {
    return this.$_.get(route, "meta.guard", () => true)(this);
  }

  public checkRoutePermissions(route) {
    const permissions = this.$_.get(route, "meta.auth", []);
    return this.$userCan(...permissions);
  }
}
